// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-autocomplete--chips.v-input--density-compact .v-field--variant-solo .v-label.v-field-label--floating,
:where(.vuetify-styles) .v-autocomplete--chips.v-input--density-compact .v-field--variant-solo-inverted .v-label.v-field-label--floating,
:where(.vuetify-styles) .v-autocomplete--chips.v-input--density-compact .v-field--variant-filled .v-label.v-field-label--floating,
:where(.vuetify-styles) .v-autocomplete--chips.v-input--density-compact .v-field--variant-solo-filled .v-label.v-field-label--floating {
  top: 0px;
}
:where(.vuetify-styles) .v-autocomplete .v-field .v-text-field__prefix,
:where(.vuetify-styles) .v-autocomplete .v-field .v-text-field__suffix,
:where(.vuetify-styles) .v-autocomplete .v-field .v-field__input,
:where(.vuetify-styles) .v-autocomplete .v-field .v-field__input > input,
:where(.vuetify-styles) .v-autocomplete .v-field.v-field {
  cursor: text;
}
:where(.vuetify-styles) .v-autocomplete .v-field .v-field__input > input {
  flex: 1 1;
}
:where(.vuetify-styles) .v-autocomplete .v-field input {
  min-width: 64px;
}
:where(.vuetify-styles) .v-autocomplete .v-field:not(.v-field--focused) input {
  min-width: 0;
}
:where(.vuetify-styles) .v-autocomplete .v-field--dirty .v-autocomplete__selection {
  margin-inline-end: 2px;
}
:where(.vuetify-styles) .v-autocomplete .v-autocomplete__selection-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:where(.vuetify-styles) .v-autocomplete__content {
  overflow: hidden;
}
:where(.vuetify-styles) .v-autocomplete__content {
  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-menu > .v-overlay__content.v-autocomplete__content {
  border-radius: 4px;
}

:where(.vuetify-styles) .v-autocomplete__content > .v-sheet {
  display: flex;
  flex-direction: column;
}
:where(.vuetify-styles) .v-autocomplete__mask {
  background: rgb(var(--v-theme-surface-light));
}
:where(.vuetify-styles) .v-autocomplete__selection {
  display: inline-flex;
  align-items: center;
  height: 1.5rem;
  letter-spacing: inherit;
  line-height: inherit;
  max-width: calc(100% - 2px - 2px);
}
:where(.vuetify-styles) .v-autocomplete__selection:first-child {
  margin-inline-start: 0;
}
:where(.vuetify-styles) .v-autocomplete--selecting-index .v-autocomplete__selection {
  opacity: var(--v-medium-emphasis-opacity);
}
:where(.vuetify-styles) .v-autocomplete--selecting-index .v-autocomplete__selection--selected {
  opacity: 1;
}
:where(.vuetify-styles) .v-autocomplete--selecting-index .v-field__input > input {
  caret-color: transparent;
}
:where(.vuetify-styles) .v-autocomplete--single:not(.v-autocomplete--selection-slot).v-text-field input {
  flex: 1 1;
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  padding-inline: inherit;
}
:where(.vuetify-styles) .v-autocomplete--single:not(.v-autocomplete--selection-slot) .v-field--active input {
  transition: none;
}
:where(.vuetify-styles) .v-autocomplete--single:not(.v-autocomplete--selection-slot) .v-field--dirty:not(.v-field--focused) input {
  opacity: 0;
}
:where(.vuetify-styles) .v-autocomplete--single:not(.v-autocomplete--selection-slot) .v-field--focused .v-autocomplete__selection {
  opacity: 0;
}
:where(.vuetify-styles) .v-autocomplete__menu-icon {
  margin-inline-start: 4px;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-autocomplete--active-menu .v-autocomplete__menu-icon {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VAutocomplete/VAutocomplete.css"],"names":[],"mappings":"AAAA;;;;EAIE,QAAQ;AACV;AACA;;;;;EAIE,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,wOAAwO;AAC1O;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,iCAAiC;AACnC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".v-autocomplete--chips.v-input--density-compact .v-field--variant-solo .v-label.v-field-label--floating,\n.v-autocomplete--chips.v-input--density-compact .v-field--variant-solo-inverted .v-label.v-field-label--floating,\n.v-autocomplete--chips.v-input--density-compact .v-field--variant-filled .v-label.v-field-label--floating,\n.v-autocomplete--chips.v-input--density-compact .v-field--variant-solo-filled .v-label.v-field-label--floating {\n  top: 0px;\n}\n.v-autocomplete .v-field .v-text-field__prefix,\n.v-autocomplete .v-field .v-text-field__suffix,\n.v-autocomplete .v-field .v-field__input,\n.v-autocomplete .v-field .v-field__input > input, .v-autocomplete .v-field.v-field {\n  cursor: text;\n}\n.v-autocomplete .v-field .v-field__input > input {\n  flex: 1 1;\n}\n.v-autocomplete .v-field input {\n  min-width: 64px;\n}\n.v-autocomplete .v-field:not(.v-field--focused) input {\n  min-width: 0;\n}\n.v-autocomplete .v-field--dirty .v-autocomplete__selection {\n  margin-inline-end: 2px;\n}\n.v-autocomplete .v-autocomplete__selection-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.v-autocomplete__content {\n  overflow: hidden;\n}\n.v-autocomplete__content {\n  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-menu > .v-overlay__content.v-autocomplete__content {\n  border-radius: 4px;\n}\n\n.v-autocomplete__content > .v-sheet {\n  display: flex;\n  flex-direction: column;\n}\n.v-autocomplete__mask {\n  background: rgb(var(--v-theme-surface-light));\n}\n.v-autocomplete__selection {\n  display: inline-flex;\n  align-items: center;\n  height: 1.5rem;\n  letter-spacing: inherit;\n  line-height: inherit;\n  max-width: calc(100% - 2px - 2px);\n}\n.v-autocomplete__selection:first-child {\n  margin-inline-start: 0;\n}\n.v-autocomplete--selecting-index .v-autocomplete__selection {\n  opacity: var(--v-medium-emphasis-opacity);\n}\n.v-autocomplete--selecting-index .v-autocomplete__selection--selected {\n  opacity: 1;\n}\n.v-autocomplete--selecting-index .v-field__input > input {\n  caret-color: transparent;\n}\n.v-autocomplete--single:not(.v-autocomplete--selection-slot).v-text-field input {\n  flex: 1 1;\n  position: absolute;\n  left: 0;\n  right: 0;\n  width: 100%;\n  padding-inline: inherit;\n}\n.v-autocomplete--single:not(.v-autocomplete--selection-slot) .v-field--active input {\n  transition: none;\n}\n.v-autocomplete--single:not(.v-autocomplete--selection-slot) .v-field--dirty:not(.v-field--focused) input {\n  opacity: 0;\n}\n.v-autocomplete--single:not(.v-autocomplete--selection-slot) .v-field--focused .v-autocomplete__selection {\n  opacity: 0;\n}\n.v-autocomplete__menu-icon {\n  margin-inline-start: 4px;\n  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-autocomplete--active-menu .v-autocomplete__menu-icon {\n  transform: rotate(180deg);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
